import { InfoIcon } from '@chakra-ui/icons';
import {
  Button,
  Card,
  CardBody,
  Divider,
  Flex,
  FormControl,
  FormHelperText,
  FormLabel,
  HStack,
  Input,
  Text,
  Tooltip,
  VStack,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { ROUTES } from '@/routes/Routes';
import PageLayout from '@/ui/Layout/PageLayout';
import { LivelinxLogo } from '@/ui/Logo';
import { getAccessLinkUrl } from '@/utils/helpers/getAccessLinkUrl';

type FormData = {
  accessCode: string;
};

export default function AccessLinkEnterCodePage() {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>();

  const onSubmit = (formData: FormData) => {
    window.location.href = getAccessLinkUrl(formData.accessCode);
  };
  return (
    <PageLayout showHeader={false}>
      <HStack padding={4}>
        <Link to={ROUTES.HOME} reloadDocument>
          <LivelinxLogo />
        </Link>
      </HStack>
      <Flex width="100%" height="100%" alignItems="center" justifyContent="center" flexDir="column">
        <Card
          maxW={{ base: '80%', md: '40%' }}
          width="100%"
          px={4}
          shadow="2xl"
          border="1px solid black"
        >
          <CardBody>
            <Text fontSize="2xl" width="100%" textAlign="center">
              {t('accessLinkEnterCodePage.title')}
            </Text>
            <Divider my={4} width="100%" />
            <form onSubmit={(e) => void handleSubmit(onSubmit)(e)}>
              <Flex width="100%" justifyContent="center">
                <VStack gap="10px" pb="10px" maxW={{ base: '100%', md: '75%' }} width="100%">
                  <FormControl isRequired isInvalid={Boolean(errors.accessCode)}>
                    <HStack alignItems="top">
                      <FormLabel fontSize="sm" fontWeight="normal">
                        {t('accessLinkEnterCodePage.form.accessCode.label')}
                      </FormLabel>
                      <Tooltip label={t('accessLinkEnterCodePage.form.accessCode.tooltip')}>
                        <InfoIcon color="gray" position="relative" left={-3} top={1} boxSize={3} />
                      </Tooltip>
                    </HStack>
                    <Input
                      type="text"
                      {...register('accessCode', { required: true })}
                      placeholder="ex: vs9asilt4xk"
                    />
                    {errors.accessCode && (
                      <FormHelperText color="red">
                        {t('accessLinkEnterCodePage.form.accessCode.error')}
                      </FormHelperText>
                    )}
                  </FormControl>

                  <Button
                    onClick={() => void handleSubmit(onSubmit)()}
                    p="2"
                    width="full"
                    background="blue.400"
                    color="white"
                    variant="solid"
                  >
                    {t('accessLinkEnterCodePage.form.submit.label')}
                  </Button>
                </VStack>
              </Flex>
            </form>
          </CardBody>
        </Card>
      </Flex>
    </PageLayout>
  );
}
